import { GitGraphProtocolError } from '@web-git-graph/protocol';
import { GIT_GRAPH_CONTENT_TYPE } from '@web-git-graph/protocol/http';

// src/providers/http.ts
var HttpGitGraphProvider = class {
  baseUrl;
  repositoryId;
  #fetch;
  #headers;
  constructor(options) {
    this.baseUrl = options.baseUrl.replace(/\/+$/, "");
    this.repositoryId = options.repositoryId;
    this.#fetch = options.fetch ?? globalThis.fetch.bind(globalThis);
    this.#headers = options.headers;
  }
  async getCapabilities(signal) {
    return this.#request("/v1/capabilities", { signal });
  }
  async listRepositories(signal) {
    return this.#request("/v1/repositories", { signal });
  }
  async getHistory(request = {}) {
    const repositoryId = request.repositoryId ?? this.repositoryId;
    if (!repositoryId) throw new TypeError("repositoryId is required");
    const query = new URLSearchParams();
    if (request.refs?.length) for (const ref of request.refs) query.append("ref", ref);
    else if (request.ref) query.set("ref", request.ref);
    if (request.cursor) query.set("cursor", request.cursor);
    if (request.limit) query.set("limit", String(request.limit));
    if (request.includeWorkingTree !== void 0) {
      query.set("includeWorkingTree", String(request.includeWorkingTree));
    }
    return this.#request(
      `/v1/repositories/${encodeURIComponent(repositoryId)}/history?${query.toString()}`,
      { signal: request.signal }
    );
  }
  async getCommitDetails(repositoryId, revision, signal) {
    const id = repositoryId ?? this.repositoryId;
    if (!id) throw new TypeError("repositoryId is required");
    const oid = revision.kind === "working-tree" ? "__WORKTREE__" : revision.oid;
    return this.#request(
      `/v1/repositories/${encodeURIComponent(id)}/commits/${encodeURIComponent(oid)}`,
      { signal }
    );
  }
  async compare(repositoryId, base, head, signal) {
    return this.#post(repositoryId, "compare", { base, head }, signal);
  }
  async getFileDiff(repositoryId, base, head, path, context = 3, signal) {
    return this.#post(repositoryId, "diff", { base, head, path, context }, signal);
  }
  async #post(repositoryId, action, body, signal) {
    const id = repositoryId ?? this.repositoryId;
    if (!id) throw new TypeError("repositoryId is required");
    return this.#request(`/v1/repositories/${encodeURIComponent(id)}/${action}`, {
      method: "POST",
      body: JSON.stringify(body),
      signal
    });
  }
  async #request(path, init) {
    const configured = typeof this.#headers === "function" ? await this.#headers() : this.#headers;
    const headers = new Headers(configured);
    headers.set("accept", GIT_GRAPH_CONTENT_TYPE);
    if (init.body) headers.set("content-type", "application/json");
    const response = await this.#fetch(`${this.baseUrl}${path}`, { ...init, headers });
    const body = await response.json();
    if (!response.ok) {
      const error = body.error;
      throw new GitGraphProtocolError(error?.code ?? "internal_error", error?.message ?? response.statusText, {
        retryable: error?.retryable ?? response.status >= 500,
        details: { httpStatus: response.status, ...error?.details }
      });
    }
    return body;
  }
};

export { HttpGitGraphProvider };
//# sourceMappingURL=http.js.map
//# sourceMappingURL=http.js.map